import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { BreadcrumbRouterComponent } from '../../../shared/components/breadcrumb/breadcrumb-router/breadcrumb-router.component'
import { SidebarToggleDirective } from '../../../shared/components/sidebar/sidebar-toggle.directive'
import { AppStoreService } from '../../../core/app-state.service'
import { UserOffcanvasService } from '../../../shared/components/user-offcanvas/user-offcanvas.service'
import { SupportImpersonationService } from '../../../secure/features/support/services/support-impersonation.service'
import { ToastrService } from 'ngx-toastr'

@Component({
    selector: 'sq-secure-header',
    imports: [FontAwesomeModule, BreadcrumbRouterComponent, SidebarToggleDirective],
    templateUrl: './secure-header.component.html',
    styleUrl: './secure-header.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        class: 'header header-sticky p-0 mb-4',
    },
})
export class SecureHeaderComponent {
    appStore = inject(AppStoreService)
    #userOffcanvasService = inject(UserOffcanvasService)
    #impersonationService = inject(SupportImpersonationService)
    #toastr = inject(ToastrService)

    me = this.appStore.me

    menuToggle = output<void>()

    sidebarId = input('sidebar1')

    openUserProfile(): void {
        this.#userOffcanvasService.open(this.me(), this.appStore.company())
    }

    stopImpersonation(): void {
        this.#impersonationService.stopImpersonation().subscribe({
            next: () => {
                this.#toastr
                    .success(
                        `You are no longer impersonating this user. Click this message to continue or wait 5 seconds to be redirected.`,
                        undefined,
                        { extendedTimeOut: 5000 }
                    )
                    .onTap.subscribe(() => {
                        window.location.href = '/'
                    })

                setTimeout(() => (window.location.href = '/'), 5000)
            },
            error: () => {
                this.#toastr.error('Failed to stop impersonation, please try again later.')
            },
        })
    }
}
